import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M5.83341 5.83333H13.9584C15.714 5.83333 16.5918 5.83333 17.2223 6.25466C17.4953 6.43706 17.7297 6.67143 17.9121 6.94441C18.3334 7.57497 18.3334 8.45276 18.3334 10.2083C18.3334 13.1343 18.3334 14.5973 17.6312 15.6482C17.3272 16.1032 16.9366 16.4938 16.4816 16.7978C15.4307 17.5 13.9677 17.5 11.0417 17.5H10.0001C6.07171 17.5 4.10752 17.5 2.88714 16.2796C1.66675 15.0592 1.66675 13.095 1.66675 9.16667V6.62023C1.66675 5.1065 1.66675 4.34964 1.98368 3.78172C2.2096 3.37689 2.54364 3.04285 2.94847 2.81693C3.51638 2.5 4.27325 2.5 5.78697 2.5C6.75677 2.5 7.24166 2.5 7.66613 2.65917C8.63527 3.0226 9.0349 3.90298 9.47222 4.7776L10.0001 5.83333",
      stroke: "#C1C1C1",
      "stroke-width": "1.5",
      "stroke-linecap": "round"
    }, null, -1)
  ]))]))
}
export default { render: render }